import { render, staticRenderFns } from "./VueTip.vue?vue&type=template&id=9d0c3416&"
import script from "./VueTip.vue?vue&type=script&lang=js&"
export * from "./VueTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports